import React from "react";
import { Button, makeStyles } from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";

const useStyles = makeStyles((theme) => ({
  floatRight: {
    float: "right !important",
  },
  fieldSuperVisorButton: {
    fontSize: 11,
    paddingLeft: 8,
    paddingRight: 8,
    width: 92,
    marginTop: 15,
    paddingTop: 3,
    paddingBottom: 3,
    marginLeft: 6,
  },
  mt15: {
    marginTop: 15,
  },
  mL10: {
    marginLeft: 10,
  },
  nameLable: {
    textTransform: "capitalize",
    fontWeight: 500,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function ViewSectorOfficer(props) {
  const classes = useStyles();

  const closeViewSectorOfficerDailogBox = (action, sectorOfficer) => {
    props.onUpdate(action, sectorOfficer);
  };

  const renderViewSectorOfficerDailogContent = () => {
    return (
      <div>
        {props.sectorOfiicer.sectorOfficerList.map((sectorOfficer, idx) => (
          <GridContainer key={idx}>
            <GridItem xs={12} sm={12} md={7}>
              <div className={classes.mt15}>
                <span className={classes.nameLable}>
                  {sectorOfficer && sectorOfficer.user_details
                    ? sectorOfficer.user_details.name
                    : "--"}
                </span>
              </div>
            </GridItem>
            {/* <GridItem xs={12} sm={12} md={2}>
              <Button
                onClick={() =>
                  closeViewSectorOfficerDailogBox("view_team", sectorOfficer)
                }
                color="primary"
                className={classes.fieldSuperVisorButton}
                variant="outlined"
              >
                View teams
              </Button>
            </GridItem> */}
            <GridItem xs={12} sm={12} md={2}>
              <Button
                onClick={() =>
                  closeViewSectorOfficerDailogBox("create_team", sectorOfficer)
                }
                className={classes.fieldSuperVisorButton}
                variant="outlined"
              >
                Create team
              </Button>
            </GridItem>
          </GridContainer>
        ))}
      </div>
    );
  };
  return (
    <Dialog
      TransitionComponent={Transition}
      maxWidth={"sm"}
      onClose={closeViewSectorOfficerDailogBox}
      fullWidth={true}
      open={props.sectorOfiicer.isDialogOpen}
      aria-labelledby="view-sector-officer-dailog-label"
    >
      <DialogTitle id="view-sector-officer-dailog-label">
        VIEW SECTOR OFFICER
      </DialogTitle>
      <DialogContent>{renderViewSectorOfficerDailogContent()}</DialogContent>
      <DialogActions>
        <Button
          onClick={() => closeViewSectorOfficerDailogBox("close", null)}
          color="primary"
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
